import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import Select from 'react-select';
import InputField from "../../utils/InputField";
import TextAreaField from "../../utils/TextAreaField";
import StaticFunctions from "../../utils/StaticFunctions";
import CheckBoxField from "../../utils/CheckBoxField";

class CompanyAddContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        timezones: PropTypes.array.isRequired,
        changeView: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            inputError: [],
            currentParentCompany: null,
            parentCompanyList: [],
            inputParams: {
                parentId: '',
                name: '',
                info: '',
                timezone: this.props.baseData.companies.currentCompany.timezone,
                apiEnabled: false,
                aiConnectorEnabled: false,
            },
        };

        this.translate = this.props.baseData.translate;

        this.requestParentCompanies = this.requestParentCompanies.bind(this);
        this.selectParentCompany = this.selectParentCompany.bind(this);
        this.selectTimezone = this.selectTimezone.bind(this);
        this.getInput = this.getInput.bind(this);

    }

    componentWillMount() {

        this.requestParentCompanies();

    }

    requestParentCompanies() {

        const params = {
            action: 'getParentCompanies',
            currentCompanyId: this.props.baseData.companies.currentCompany.id
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    parentCompanyList: res,
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback, null);

    }

    getInput(event, name, value, isValid) {

        const inputParams = {...this.state.inputParams};

        inputParams[name] = value;

        if (isValid) {
            this.removeInputError(name);
        } else {
            this.addInputError(name);
        }

        this.setState({inputParams});

    }

    selectParentCompany(event) {

        if (!event || !event.value) return;

        const inputParams = {...this.state.inputParams};

        if (inputParams) {
            inputParams.parentId = event.value;

            this.setState({
                inputParams,
                currentParentCompany: this.getCompanyById(event.value)
            });
        }

    }

    selectTimezone(event) {

        if (!event || !event.value) return;

        const inputParams = {...this.state.inputParams};

        if (inputParams) {
            inputParams.timezone = event.value;

            this.setState({
                inputParams
            });
        }

    }

    enterSaveNewCompany(event) {

        if (event.keyCode === 13) {
            this.saveNewCompany();
        } else if (event.keyCode === 27) {
            this.props.changeView();
        }

    }

    saveNewCompany() {

        const inputError = this.state.inputError;
        const inputParams = this.state.inputParams;

        if (inputError.length === 0 && inputParams && inputParams.name) {
            const params = {
                action: 'addCompany',
                currentCompanyId: this.props.baseData.companies.currentCompany.id,
                parentId: inputParams.parentId,
                name: inputParams.name,
                info: inputParams.info,
                timezone: inputParams.timezone,
                vatNumber: inputParams.vatNumber,
                apiEnabled: inputParams.apiEnabled,
                aiConnectorEnabled: inputParams.aiConnectorEnabled
            };

            const callback = function (res) {
                this.resetInputError();

                if (res.success) {
                    alert(this.translate(res.msgKey));

                    if (this.props.baseData.requestCompanies) {
                        this.props.baseData.requestCompanies();
                    }

                    this.props.changeView();
                } else {
                    this.setInputError(res.errors);
                }
            }.bind(this);

            this.api.request('AdminFunctions', params, callback, null);
        } else {
            if (!inputParams.name) this.addInputError('name');

            alert(this.translate('errorOccured'));
        }

    }

    changeView() {

        if (this.props.changeView) this.props.changeView();

    }

    setInputError(errorFields) {

        this.setState({
            inputError: errorFields,
        });

    }

    addInputError(field) {

        const errorFields = this.state.inputError;

        errorFields.push(field);

        this.setState({
            inputError: errorFields,
        });

    }

    removeInputError(field) {

        const errorFields = this.state.inputError.filter(e => e !== field);

        this.setState({
            inputError: errorFields,
        });

    }

    resetInputError() {

        this.setState({
            inputError: [],
        });

    }

    checkInputError(fieldName) {

        let result = 'ok';

        if (this.state.inputError) {
            let errorList = this.state.inputError;

            if (errorList.indexOf(fieldName) >= 0) result = 'error';
        }

        return result;

    }

    getSelectParentCompanies() {

        if (this.state.parentCompanyList) {
            return this.state.parentCompanyList.map((company) => {
                return {
                    label: company['name'] + ' (' + company['id'] + ')',
                    value: company['id']
                }
            });
        }

        return [];

    }

    getTimezones() {

        return this.props.timezones.map((tz) => {
            let gmt = StaticFunctions.getGmtFromTimezoneString(tz);
            let label = tz + ((gmt) ? ' ' + gmt : '');

            return {
                label: label,
                value: tz
            }
        });

    }

    getCompanyById(companyId) {

        const companies = this.state.parentCompanyList;

        let company = null;

        if (companyId && companies) {
            companies.forEach(
                (comp) => {
                    if (comp.id === companyId) {
                        company = comp;
                    }
                }
            );
        }

        return company;

    }

    render() {

        const inputParams = this.state.inputParams;
        const parentCompanies = this.getSelectParentCompanies();
        const selectedParentCompanyId = (inputParams) ? inputParams.parentId : null;
        const disabledCompanySelection = (parentCompanies.length === 1);

        return (
            <div className="formSettings clearfix">
                <div className="ma-bo-20 clearfix">
                    <div>
                        <nav>
                            <h1>{this.translate('addCompany')}</h1>
                        </nav>
                    </div>

                    <div className="formRow">
                        <table>
                            <tbody>
                                <tr>
                                    <td className="text-left labelSpan">{this.translate('name')}</td>

                                    <td className="text-left">
                                        <InputField
                                            name="name"
                                            className={this.checkInputError('name')}
                                            value={inputParams.name}
                                            onBlur={this.getInput}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('parentCompany')}</td>

                                    <td className="text-left">
                                        <Select
                                            name="parentId"
                                            className="chosen-container chosen-container-single"
                                            style={{width: '260px'}}
                                            options={parentCompanies}
                                            onChange={this.selectParentCompany}
                                            value={parentCompanies.find(o => String(o.value) === String(selectedParentCompanyId)) || null}
                                            placeholder={this.translate('select') + '...'}
                                            clearable={false}
                                            noResultsText={this.translate('noResultsFound')}
                                            disabled={disabledCompanySelection}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('timezone')}</td>

                                    <td className="text-left">
                                        {(() => {
                                            const timezones = this.getTimezones();
                                            const selectedTimezone = timezones.find(o => String(o.value) === String(inputParams.timezone)) || null;
                                            return (
                                                <Select
                                                    name="timezone"
                                                    className="chosen-container chosen-container-single"
                                                    style={{width: '260px'}}
                                                    options={timezones}
                                                    tabIndex="4"
                                                    value={selectedTimezone}
                                                    placeholder={this.translate('select') + '...'}
                                                    clearable={false}
                                                    noResultsText={this.translate('noResultsFound')}
                                                    onChange={this.selectTimezone}
                                                />
                                            );
                                        })()}
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('info')}</td>

                                    <td className="text-left">
                                        <TextAreaField
                                            name="info"
                                            value={inputParams.info}
                                            onBlur={this.getInput}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('vatNumber')}</td>

                                    <td className="text-left">
                                        <InputField
                                            name="vatNumber"
                                            className={this.checkInputError('vatNumber')}
                                            value={inputParams.vatNumber}
                                            isRequired={false}
                                            onBlur={this.getInput}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('customerApi')}</td>

                                    <td className="text-left">
                                        <CheckBoxField
                                            name="apiEnabled"
                                            label={""}
                                            isChecked={inputParams.apiEnabled}
                                            onChange={(name, value) => this.getInput(null, name, value, true)}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('aiConnector')}</td>

                                    <td className="text-left">
                                        <CheckBoxField
                                            name="aiConnectorEnabled"
                                            label={""}
                                            isChecked={inputParams.aiConnectorEnabled}
                                            onChange={(name, value) => this.getInput(null, name, value, true)}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">&nbsp;</td>

                                    <td className="text-left">
                                        <a className="formButton" onClick={() => this.changeView()}>
                                            {this.translate('cancel')}
                                        </a>

                                        <a className="formButton" onClick={() => this.saveNewCompany()} onKeyDown={(event) => this.enterSaveNewCompany(event)}>
                                            {this.translate('save')}
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );

    }

}

export default CompanyAddContainer;
